'use es6';

import { MODIFIERS, hasShiftKey, hasCommandKey } from 'DesignData/enums/Keys';
export const getKeybindingHandler = (keybindingConfig, e) => {
  let selectedKeybindings = keybindingConfig[MODIFIERS.NONE];

  if (hasCommandKey(e) && hasShiftKey(e)) {
    selectedKeybindings = keybindingConfig[MODIFIERS.COMMAND_SHIFT];
  } else if (hasCommandKey(e) && !hasShiftKey(e)) {
    selectedKeybindings = keybindingConfig[MODIFIERS.COMMAND];
  } else if (hasShiftKey(e) && !hasCommandKey(e)) {
    selectedKeybindings = keybindingConfig[MODIFIERS.SHIFT];
  }

  const keybinding = selectedKeybindings ? selectedKeybindings[e.keyCode] || selectedKeybindings[e.code] : null;
  return keybinding ? keybinding.handler : null;
};